"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const polished_1 = require("polished");
const colorPalette_1 = __importDefault(require("./colorPalette"));
/**
 * @deprecated please use `packages/theme/src/novo/novoDark.js`
 */
const color = {
    // Tokens
    // Page background
    // Dialpad background
    // Overflow menu background
    // Modal background
    // Calendar container
    uiBackground01: colorPalette_1.default.colorPurple01,
    // High contrast background
    // Tooltip background
    uiBackground02: colorPalette_1.default.colorGray10,
    // Primary action colour
    // Primary buttons
    action01: colorPalette_1.default.colorBlue06,
    // Secondary action color
    // Secondary buttons
    action02: colorPalette_1.default.colorGray09,
    // Link on high contrast backgrounds
    action03: colorPalette_1.default.colorBlue05,
    // Selected elements
    // Active elements
    action04: colorPalette_1.default.colorBlue06,
    // Links
    action05: colorPalette_1.default.colorBlue07,
    // Destructive button background
    // Text
    // Icon
    // Border
    destructive01: colorPalette_1.default.colorRed06,
    // Primary text
    // Body copy
    // Headers
    // Labels
    // Secondary buttons
    text01: colorPalette_1.default.colorWhite,
    // Secondary text
    // Placeholder text
    // Helper text
    text02: colorPalette_1.default.colorGray08,
    // TODO: removed?
    text03: colorPalette_1.default.colorGray08,
    // Text on interactive colours
    // Reverse text colour
    // Reverse icon colour
    text04: colorPalette_1.default.colorGray02,
    // Data table row text
    text05: colorPalette_1.default.colorGray08,
    // Button Primary, Destructive
    text06: colorPalette_1.default.colorWhite,
    // Error text
    // Error icons
    error01: colorPalette_1.default.colorRed07,
    // Success button
    // Success icons
    success01: colorPalette_1.default.colorGreen05,
    // Warning icons
    // Notification counter primary
    warning01: colorPalette_1.default.colorYellow05,
    // Impartial
    info01: colorPalette_1.default.colorGray05,
    // Subtle border
    // Progress indicator background
    ui01: colorPalette_1.default.colorGray05,
    // Secondary background
    // Border
    ui02: colorPalette_1.default.colorGray03,
    // Off states
    ui03: colorPalette_1.default.colorGray06,
    // Emphasis form elements
    // Tab border hover
    // Shadows
    ui04: colorPalette_1.default.colorWhite,
    // Default input fields
    // Zebra highlighting in tables
    ui05: colorPalette_1.default.colorPurple02,
    // Overlay background
    overlay: (0, polished_1.rgba)(colorPalette_1.default.colorGray02, 0.75),
    // Dialog shadows
    shadow: colorPalette_1.default.colorGray01,
    // Primary icons
    icon01: colorPalette_1.default.colorWhite,
    // Icons on interactive colors
    icon02: colorPalette_1.default.colorWhite,
    // Disabled icons on backgrounds
    icon03: colorPalette_1.default.colorGray05,
    // Coachmark icon
    icon04: colorPalette_1.default.colorBlue05,
    // Icons on secondary buttons
    icon05: colorPalette_1.default.colorGray02,
    // Disabled icons
    icon06: colorPalette_1.default.colorGray05,
    // Interactive tokens
    // Focus
    focus01: colorPalette_1.default.colorBlue05,
    // Disabled backgrounds
    disabled01: colorPalette_1.default.colorGray08,
    // Disabled text
    disabled02: colorPalette_1.default.colorGray05,
    // Disabled on high contrast background
    disabled03: colorPalette_1.default.colorGray08,
    // Disabled text on buttons
    disabled04: colorPalette_1.default.colorGray06,
    // Primary button hover
    hover01: colorPalette_1.default.colorBlue07,
    // Primary button active
    active01: colorPalette_1.default.colorBlue05,
    // Secondary button hover
    hover02: colorPalette_1.default.colorGray10,
    // Secondary button active
    active02: colorPalette_1.default.colorGray08,
    // Destructive button hover
    hover03: colorPalette_1.default.colorRed07,
    // Destructive button active
    active03: colorPalette_1.default.colorRed05,
    // Success button hover
    hover04: colorPalette_1.default.colorGreen06,
    // Success button active
    active04: colorPalette_1.default.colorGreen04,
    // Icon hover
    hover05: colorPalette_1.default.colorGray03,
    // Icon active
    active05: colorPalette_1.default.colorGray05,
    // Icon selected
    selected05: colorPalette_1.default.colorBlue06,
    // Dropdown hover
    // Overflow menu hover
    // Date picker number hover
    hover06: colorPalette_1.default.colorGray03,
    // Links hover
    hover07: colorPalette_1.default.colorBlue08,
    // Links active
    active07: colorPalette_1.default.colorBlue05,
    // Dialpad number hover
    hover08: colorPalette_1.default.colorPurple02,
    // Dialpad number active
    active08: colorPalette_1.default.colorGray04,
};
exports.default = color;
